module.exports = __webpack_public_path__ + "img/axy_axreyltokens.0d5d129.png";